module.exports = __webpack_public_path__ + "img/storage.b3554fb.svg";